import { lazy } from 'react';
import { wrapLazyNavigatorScreen } from '../../functions/navigation/utils/wrapNavigatorScreen';

const ShowCasePageContentWithErrorBoundary = lazy(
  () => import('./ShowCasePageContent'),
);

const ShowCasePage = wrapLazyNavigatorScreen(
  ShowCasePageContentWithErrorBoundary,
  {
    detachPreviousScreen: false,
    animationEnabled: false,
    gestureEnabled: false,
    cardStyle: { backgroundColor: 'transparent' },
    headerShown: false,
    presentation: 'transparentModal',
  },
);

export default ShowCasePage;
